module.exports = __webpack_public_path__ + "components/flag/static/square/kh-ed169c542f45617e98f44d4caa2930d4.svg";